import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './DAL/store';
import CompareServersApp from "./App/CompareServersApp";
import {getJSONFromHtml} from "../../../domain/common";
import {ProductCompareWrapper} from "./interfaces";

const init = () => {
    const $CompareServersRoot = document.getElementById('compare-servers-app');
    if (!$CompareServersRoot) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
            <CompareServersApp />
            </Provider>
            </React.StrictMode>,
        $CompareServersRoot
);
};

init();